import React, { useContext } from "react";

import { RetroLayout } from "components/retrospective/RetroLayout";
import { RetroCard } from "components/retrospective/RetroCard";
import { makeStyles } from "tss-react/mui";
import { Grid, Typography } from "@mui/material";
import { VictoryArea, VictoryAxis, VictoryChart } from "victory";
import { RetroContext } from "components/retrospective/RetrospectiveMain";
import { formatMonthLabel, normalizeTimeValues } from "logic/Charts";
import { RETRO_AXIS_STYLE, CHART_PADDING } from "components/charts/chartStyles";

const PAGE_DATA = {
  title: "Redução de CO₂",
  subtitle: "Seu impacto direto na atmosfera",
  bgGradient: "linear-gradient(135deg, #096 0%, #009689 50%, #0092B8 100%)",
  illustrationSrc: "/static/img/retro2025/co2Img.png",
  bgImage: "/static/img/retro2025/co2.jpg",
  pageNum: "1",
};

const useStyles = makeStyles()((theme) => ({
  data: {
    display: "grid",
    gap: theme.spacing(3),
    paddingTop: theme.spacing(2),
    height: "100%",

    // vertical
    gridTemplateRows: "repeat(3, 1fr)",
    gridTemplateColumns: "100%",
  },
  chart: {
    display: "grid",
    gridTemplateColumns: "100%",
    gridTemplateRows: "90% 10%",
    height: "100%",
    width: "100%",
  },
  chartArea: {
    gridRow: "span 1",
  },
  chartCaption: {
    gridRow: "span 1",
  },
}));

export const RetroCO2 = () => {
  const { classes } = useStyles();
  const { co2EvitadoTotal, monthlyCO2 } = useContext(RetroContext);

  return (
    <RetroLayout {...PAGE_DATA}>
      <Grid item container className={classes.data}>
        <RetroCard
          variant="dark"
          gridColumnHorizontal="span 1"
          gridRowHorizontal="span 2"
          gridColumnVertical="span 1"
          gridRowVertical="span 2"
        >
          <Grid className={classes.chart}>
            <Grid item container className={classes.chartArea}>
              <svg width="0" height="0" viewBox="0 0 0 0">
                <defs>
                  <linearGradient
                    id="c02Grad"
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="212.31"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop
                      offset="0.05"
                      stop-color="#A5B4FC"
                      stop-opacity="0.8"
                    />
                    <stop
                      offset="0.95"
                      stop-color="#A5B4FC"
                      stop-opacity="0.1"
                    />
                  </linearGradient>
                </defs>
              </svg>
              <VictoryChart padding={CHART_PADDING}>
                <VictoryAxis
                  style={RETRO_AXIS_STYLE}
                  tickFormat={formatMonthLabel}
                />
                <VictoryAxis style={RETRO_AXIS_STYLE} dependentAxis />
                <VictoryArea
                  // @ts-expect-error
                  data={monthlyCO2}
                  x={({ mes }) => normalizeTimeValues({ time: mes, value: 0 })}
                  y="co2Evitado"
                  style={{
                    data: {
                      stroke: "#A5B4FCCC",
                      fill: "url(#c02Grad)",
                    },
                  }}
                />
              </VictoryChart>
            </Grid>
            <Typography
              color="common.white"
              variant="body2"
              align="center"
              className={classes.chartCaption}
            >
              CO₂ Evitado Mensal (kg)
            </Typography>
          </Grid>
        </RetroCard>

        <RetroCard
          variant="dark"
          mainInfo={co2EvitadoTotal?.toLocaleString("pt-br") || " - "}
          mainSuffix="kg"
          caption="CO₂ Evitado"
          gridColumnHorizontal="span 1"
          gridRowHorizontal="span 1"
          gridColumnVertical="span 1"
          gridRowVertical="span 1"
        />
      </Grid>
    </RetroLayout>
  );
};
